module.exports = __webpack_public_path__ + "static/media/guadalupe_optima.122127c3.png";